import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ai-quiz-generation-text-field-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_input = _resolveComponent("w-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_w_input, {
    value: _ctx.textContent,
    class: _normalizeClass(['ai-quiz-generation-text-field', _ctx.fieldType]),
    type: _ctx.fieldType,
    placeholder: _ctx.placeholder,
    enabled: !_ctx.disabled,
    resize: "none",
    onInput: _ctx.onContentChange
  }, null, 8, ["value", "class", "type", "placeholder", "enabled", "onInput"])]);
}